module.exports = __webpack_public_path__ + "img/SketchPng34223ddfebbb9e03ed0501095d1122c734365e07bfdee248c00cc78bc5a92caf.db5e8c42.png";